import { ReactElement } from "react";
import PoweredByNumberFire from "@/components/svg/PoweredByNumberFire";
import RaceTime from "../raceTime/RaceTime";
import styles from "./horseRacingHeader.module.scss";

interface HorseRaceHeaderProps {
  title: string;
  postTime?: string | null;
  subTitle?: ReactElement;
}

const HorseRacingHeader = ({
  title,
  postTime,
  subTitle,
}: HorseRaceHeaderProps) => (
  <div className={styles.container}>
    {postTime ? (
      <div className={styles.timeContainer}>
        <RaceTime postTime={postTime} />
      </div>
    ) : (
      ""
    )}
    <h1 className={styles.title}>{title}</h1>
    {subTitle ?? ""}
    <PoweredByNumberFire />
  </div>
);

export default HorseRacingHeader;
